import { media, pxToRem } from "src/styles/styleUtils";
import styled from "styled-components";
import AdUnit from ".";

const AdArea = styled.div`
  margin-left: ${pxToRem(42)};
  flex: 0 0 ${pxToRem(216)};
  min-height: ${pxToRem(56)};

  color: ${({ theme }) => theme.grey_200};
  /* border: 1px solid ${({ theme }) => theme.grey_400};
  background-color: ${({ theme }) => theme.grey_500}; */
  font-size: ${pxToRem(10)};
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;

  ${media.tablet} {
    flex: 0 0 ${pxToRem(116)};
    min-height: ${pxToRem(30)};
    margin: 0;
    position: absolute;
    top: ${pxToRem(154)};
    left: ${pxToRem(148)};

    > div {
      max-width: ${pxToRem(116)};
      max-height: ${pxToRem(30)};
      overflow: hidden;
    }
  }

  ${media.mobile} {
    top: 84px;
    left: 140px;
  }
`;

const StyledAdUnit = styled(AdUnit)`
  flex: 0 1 ${pxToRem(216)};
  min-height: ${pxToRem(56)};
`;

export default function PicksSidebarAd() {
  return (
    <AdArea>
      <StyledAdUnit id="ad_presented_by_01" />
    </AdArea>
  );
}
